import React from "react";
import styles from "./FooterSection.module.css";
import { useTranslation } from "react-i18next";
import Paragraph, { ParagraphSize } from "../Paragraph";
import { JokerButton, ButtonType, ButtonSize } from "material-ui-jokerpro";
import FooterAccordian from "./FooterAccordian";
import { footerDataList } from "../../util/CollectionData";
import { PrivacyPolicyLink, TermsConditionLink } from "../../util/Constant";

const FooterSection = () => {
  const { t } = useTranslation();

  const data = footerDataList;

  return (
    <footer className={styles["footer"]}>
      <div className={styles["footer_text"]}>
        <Paragraph
          size={ParagraphSize.paragraph2}
          classNameStyle={styles["text_color"]}
        >
          {t("footer_section.join_us_message")}
        </Paragraph>
      </div>

      <div className={styles["footer_sections"]}>
        {data.map((element) => (
          <FooterAccordian key={element.title} data={element} />
        ))}
      </div>

      <div className={styles["footer_bottom"]}>
        <Paragraph
          size={ParagraphSize.paragraph2}
          classNameStyle={styles["text-color-black"]}
        >
          {t("footer_section.copywrite")}
        </Paragraph>
        <div className={styles["footer_bottom_links"]}>
          <JokerButton
            style={{ color: "#5f5f5f" }}
            type={ButtonType.Link}
            text={t("footer_section.privacy_policy")}
            underlined
            href={PrivacyPolicyLink}
            size={ButtonSize.Small}
          />
          <JokerButton
            style={{ color: "#5f5f5f" }}
            type={ButtonType.Link}
            text={t("footer_section.terms_of_use")}
            underlined
            href={TermsConditionLink}
            size={ButtonSize.Small}
          />
        </div>
      </div>
    </footer>
  );
};
export default FooterSection;
